class Persona{
    constructor(
      id,
      nombre,
      apellido,
      numero_afiliado,
      cuil,
      domicilio,
      localidad,
      provincia,
      codigo_postal,
      email,
      telefono,
      fecha_nacimiento,
      dni,
      tipo_documento,
      nacionalidad,
      sexo,
      piso,
      depto,
      estado_civil,
      antiguedad,
      datos_afip,
      cbu = null
    ){
        this.id = id;
        this.nombre = nombre;
        this.apellido = apellido;
        this.numero_afiliado = numero_afiliado;
        this.cuil = cuil;
        this.domicilio = domicilio;
        this.localidad = localidad;
        this.provincia = provincia;
        this.codigo_postal = codigo_postal;
        this.email = email;
        this.telefono = telefono;
        this.fecha_nacimiento = fecha_nacimiento;
        this.dni = dni;
        this.tipo_documento = tipo_documento;
        this.nacionalidad = nacionalidad;
        this.sexo = sexo;
        this.piso = piso;
        this.depto = depto;
        this.estado_civil = estado_civil;
        this.antiguedad = antiguedad;
        this.datos_afip = datos_afip;
        this.cbu = cbu;

    }
}
export default Persona;
